export const montarMsgAmigavel = (msgRetornoBack ='')=>  {
    const pattern = new RegExp (/"(.*?)"/);
    const campo = pattern.exec(msgRetornoBack);

    if (campo[0] === '"Residencia"'){
        campo[0] = 'Rua/Av';
    }

    return campo !== null ?  `O campo ${campo[0]} não pode ser vazio` : 'Erro ao cadastrar o associado, verifique todos os campos obrigatórios e tente novamente';
};